<prlw-last-deals-table-content-ui
  [data]="columnData"
></prlw-last-deals-table-content-ui>
